import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";

import { blankComponent } from "./blank.component";
import { basicComponent } from "./basic.component";

import { NavigationModule } from "../navigation/navigation.module";
import { TopnavbarModule } from "../topnavbar/topnavbar.module";
import { FooterModule } from "../footer/footer.module";
import { CabeceraModule } from "../cabecera/cabecera.module";
import { CabeceraModuleEmpresa } from "../cabeceraEmpresa/cabecera-empresa.module";

import { basicComponentEmpresa } from "./basic-empresa.component"

@NgModule({
    declarations: [blankComponent, basicComponent, basicComponentEmpresa],
    imports: [BrowserModule, RouterModule, NavigationModule, TopnavbarModule, FooterModule, CabeceraModule,CabeceraModuleEmpresa],
    exports: [blankComponent, basicComponent]
})

export class LayoutsModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/layouts/layouts.module.ts